export default {
      id: "consultation-deselected-usage",
      viewBox: "0 0 64 64",
      url: __webpack_public_path__ + "icons-sprite.626747e.svg#consultation-deselected-usage",
      toString: function () {
        return this.url;
      }
    }